<template>
    <div class="home">
      <h1>Welcome to About Page</h1>
      <p>
        About page is a simple page that shows information about the application.
      </p>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .home {
    text-align: center;
    padding: 20px;
  }
  </style>
  